import { useTranslation } from 'react-i18next';
import { ButtonType } from 'yoda-ui/components/Button/Button.types';

const TacticFieldsValidationDialogConfig = (
  handleCloseDialog: Function,
  handleSubmitDialog: Function,
) => {
  const { t } = useTranslation();

  const actionsButtonConfig = {
    cancelButtonConfig: {
      buttonProps: {
        onClick: () => handleCloseDialog(),
        buttonType: ButtonType.secondary,
      },
      label: t('maya_tactic_validation_form_cancel_button'),
    },
    submitButtonConfig: {
      buttonProps: {
        onClick: () => handleSubmitDialog(),
        buttonType: ButtonType.neutral,
      },
      label: t('maya_tactic_fields_validation_dialog_edit_button'),
    },
  };

  const fieldLabelMap: Record<string, string> = {
    IVADocumentRequired: t('maya_tactic_fields_validation_iva_document_required'),
    dropMaterialRequired: t('maya_tactic_fields_validation_drop_material_required'),
    keyMessageRequired: t('maya_tactic_fields_validation_key_message_required'),
    dateRangeRequired: t('maya_tactic_fields_validation_date_range'),
    keyMessageUnavailable: t('maya_tactic_fields_validation_key_message_unavailable'),
    dropMaterialUnavailable: t('maya_tactic_fields_validation_drop_material_unavailable'),
    IVADocumentUnavailable: t('maya_tactic_fields_validation_iva_document_unavailable'),
    approvedDocumentUnavailable: t('maya_tactic_fields_validation_approved_document_unavailable'),
  };

  return {
    actionsButtonConfig,
    fieldLabelMap,
  };
};

export default TacticFieldsValidationDialogConfig;
